import * as React from "react";
import {map as _map} from "lodash";
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import IHabitStaticData from "../../models/staticData/IHabitStaticData";
import {IConsumptionFrequency} from "../../models/patients/IPatientPersonalProfile";
import {TypeAheadElement} from "../../components/TypeAhead";
import {PatientLifestyleHabitsEditorProps} from "../../components/patient/edit/PatientLifestyleHabitsEditor";
import ModelFactory from "../../models/ModelFactory";
import IPatientWorkoutPreference from "../../models/patients/IPatientWorkoutPreference";
import IPatientHabits from "../../models/patients/IPatientHabits";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import AppUtils from "../../utils/AppUtils";
import { WorkoutPreferenceWrapper } from "@curefit/ups-common/dist/src/habits/PatientHabits";
import { PatientWorkoutPreference } from "@curefit/ups-common/dist/src/habits/PatientWorkoutPreference"

/**
 * Created by Prachi on 27/03/18.
 */
export interface HabitEditViewContainerProps {
    displayMode?: EditViewDisplayMode;
    staticPatientHabits: IHabitStaticData;
    consumptionFrequency: IConsumptionFrequency[];
    meditationPreference?: {regular: boolean, workouts: IPatientWorkoutPreference[]} | WorkoutPreferenceWrapper;
    workoutPreference?: {regular: boolean, workouts: IPatientWorkoutPreference[]} | WorkoutPreferenceWrapper;
    foodDislikes?: {
        items: string[],
    };
    fetchFitnessActivities?: (input: string) => Promise<any>;
    fetchMindfulnessActivities?: (input: string) => Promise<any>;
    fetchDishByDishName?: (input: string) => Promise<IDishCatalogueResponse | IDishCatalogueResponse[]>;
    showHabitsOnly?: boolean;
}
interface HabitEditViewContainerStates {
    [index: string]: any;
    consumptionFreq: any;
    foodDislikes: TypeAheadElement[];
    meditationPreference: {item: IPatientWorkoutPreference}[];
    workoutPreference: {item: IPatientWorkoutPreference}[];
}
export default class HabitEditViewContainer extends React.Component<HabitEditViewContainerProps, HabitEditViewContainerStates> {
    constructor(props: HabitEditViewContainerProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps = (props: HabitEditViewContainerProps) => {
        let meditationWorkouts = props.meditationPreference && props.meditationPreference.workouts ? props.meditationPreference.workouts : [];
        let fitnessWorkouts = props.workoutPreference && props.workoutPreference.workouts ? props.workoutPreference.workouts : [];
        return {
            consumptionFreq: this.formatConsumptionFreq(props.consumptionFrequency),
            foodDislikes: this.formatFoodDislikes(props.foodDislikes ? props.foodDislikes.items : []),
            meditationPreference: this.getPreferenceStateFromProps(meditationWorkouts),
            workoutPreference: this.getPreferenceStateFromProps(fitnessWorkouts)
        }
    }

    getPreferenceStateFromProps = (preferences: IPatientWorkoutPreference[] | PatientWorkoutPreference[]) => {
        let preferenceItems: {item: IPatientWorkoutPreference}[] = [];
        _map(preferences, (preference: IPatientWorkoutPreference) => {
            preferenceItems.push({item: preference})
        })
        return preferenceItems;
    }

    componentWillReceiveProps(nextProps: Readonly<HabitEditViewContainerProps>, nextContext: any): void {
        this.setState(this.getStateFromProps(nextProps));
    }

    getHabitsEditViewProps = () => {
        let editProps: PatientLifestyleHabitsEditorProps = {
            staticPatientHabits: this.props.staticPatientHabits,
            consumptionFrequency: {...this.state.consumptionFreq},
            meditationPreference: [...this.state.meditationPreference],
            workoutPreference: [...this.state.workoutPreference],
            updateHandler: this.updateHandler,
            fetchFitnessActivities: this.props.fetchFitnessActivities,
            fetchMindfulnessActivities: this.props.fetchMindfulnessActivities,
            fetchStaticDishes: this.props.fetchDishByDishName,
            showHabitsOnly: this.props.showHabitsOnly
        }
        return {"view": {}, "edit": {...editProps}};
    }
    formatConsumptionFreq = (consumptionFreq: IConsumptionFrequency[]) => {
        let consumptionFreqObj: {[index: string]: any} = {};
        if (consumptionFreq) {
            consumptionFreq.forEach((item, index) => {
                consumptionFreqObj[item.item] = {frequency: item.frequency, comment: item.comment}
            })
            return consumptionFreqObj;
        } else {
            return null;
        }
    }
    formatFoodDislikes = (dislikes: string[]) => {
        let foodDislikes: TypeAheadElement[] = [];
        if (dislikes) {
            dislikes.forEach((food, index) => {
                let dislike = {label: food, value: food};
                foodDislikes.push(dislike);
            })
        }
        return foodDislikes;
    }
    saveHabits = () => {
        //
    }
    cancelActionHandler = () => {
        //
    }
    updateHandler = (data: any, key: string) => {
        this.setState({[key]: data});
    }
    fetchFoodDislikes = () => {
        let foodDislikeList = [...this.state.foodDislikes];
        let foodDislikes = foodDislikeList.map((food, index) => {
            return food.value;
        })
        return {items: foodDislikes};
    }
    fetchConsumptionFreq = () => {
        let consumption = {...this.state.consumptionFreq};
        let frequencies = Object.keys(consumption);
        let consumptionFrequency = frequencies.map((freq, index) => {
            let item = ModelFactory.createNewHabitItem();
            const consumptionFreqItem = consumption[freq];
            item.frequency = { ...consumptionFreqItem.frequency };
            item.item = freq;
            if (AppUtils.isDefined(consumptionFreqItem.comment)) {
                item.comment = consumptionFreqItem.comment
            }
            return item;
        })
        return consumptionFrequency;
    }
    fetchWorkoutPreferences = () => {
        let preferencesToReturn: IPatientWorkoutPreference[] = [];
        let preferences = [ ...this.state.workoutPreference ];
        _map(preferences, (preference) => {
            preferencesToReturn.push(preference.item)
        })
        let workoutPreferences = preferencesToReturn.length ? { regular: true, workouts: preferencesToReturn } : { regular: false, workouts: preferencesToReturn }
        return workoutPreferences;
    }
    fetchMeditationPreferences = () => {
        let preferencesToReturn: IPatientWorkoutPreference[] = [];
        let preferences = [ ...this.state.meditationPreference ];
        _map(preferences, (preference) => {
            preferencesToReturn.push(preference.item)
        })
        let meditationPreferences = preferencesToReturn.length ? { regular: true, workouts: preferencesToReturn } : { regular: false, workouts: preferencesToReturn }
        return meditationPreferences;
    }
    getSaveObj = (): IPatientHabits => {
        return {
            genericHabits: this.fetchConsumptionFreq(),
            fitnessHabit: {
                workoutPreference: this.fetchWorkoutPreferences(),
                meditationPreference: this.fetchMeditationPreferences()
            }
        }
    }
    render() {
        return <div>
            <EditViewCard cardTitleDisplay={"Habits"} templateName={"habits"}
                          templateProps={this.getHabitsEditViewProps()}
                          lastEditedEpoch={new Date().getTime()} saveActionHandler={this.saveHabits}
                          cancelActionHandler={this.cancelActionHandler}
                          displayMode={this.props.displayMode} collapsedTextPlaceholderForMobile={"habit"} collapseInEdit={true} />
        </div>
    }
}